import React from "react";

export interface DashboardUser {
  email: string;
  fullname: string;
  avatar_url: string;
  roleName: string;
  /** Khóa người dùng để lưu xác nhận đã đọc, chỉ tiêu riêng */
  key: string;
  /** recipient_id của thông báo */
  userId: number | null;
  staffId: number | null;
  branchName: string;
}

export function readDashboardUser(): DashboardUser {
  let stored: any = {};
  try {
    stored = JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    stored = {};
  }
  return {
    email: stored.email || stored.info?.email || "",
    fullname: stored.fullname || stored.name || stored.first_name || stored.info?.fullname || "",
    avatar_url: stored.avatar || stored.avatar_url || stored.info?.avatar || "",
    roleName: stored.role?.name || stored.info?.role?.name || "",
    key: String(stored.info?.id || stored.user_id || stored.id || stored.email || "guest"),
    userId: Number(stored.user_id || stored.info?.id) || null,
    staffId: Number(stored.info?.staff_id || stored.staff_id) || null,
    branchName: stored.info?.branch?.name || stored.branch?.name || "",
  };
}

function initials(user: DashboardUser): string {
  const source = (user.fullname || user.email || "?").trim();
  const words = source.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
}

export function UserAvatar({ user, size = "sm" }: { user: DashboardUser; size?: "sm" | "lg" }) {
  const cls = size === "lg" ? "w-12 h-12 text-base" : "w-7 h-7 text-[10px]";
  if (user.avatar_url) {
    return <img src={user.avatar_url} alt={user.fullname || user.email} className={`${cls} rounded-full object-cover flex-shrink-0`} />;
  }
  return (
    <span className={`${cls} rounded-full bg-gradient-to-br from-teal-400 to-blue-500 text-white font-semibold flex items-center justify-center flex-shrink-0`}>
      {initials(user)}
    </span>
  );
}
